import { BaseElementWithoutShadowDOM } from '@theme/base-element'

export class ComponentLoadMore extends BaseElementWithoutShadowDOM {
  constructor() {
    super(...arguments)

    this.direction = ''
    this.fetchUrl = ''
    this.targetClass = ''
  }
  static get properties() {
    return {
      direction: { type: String },
      fetchUrl: { type: String, attribute: 'fetch-url' },
      targetClass: { type: String, attribute: 'target-class' },
    }
  }

  get loadButton() {
    return this.renderRoot?.querySelector('button') ?? null
  }

  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties)

    if (!this.loadButton) {
      console.error('Load more button not found')
    } else {
      this.loadButton.addEventListener('click', this.handleLoadMore.bind(this))
    }
  }

  updated(_changedProperties) {
    super.updated(_changedProperties)
  }

  handleLoadMore() {
    this.startLoading()
    const url = this.fetchUrl
    const targetClass = this.targetClass

    this.updatePageUrl(url)

    fetch(`${url}`)
      .then((response) => response.text())
      .then((html) => {
        const documentFragment = new DOMParser().parseFromString(
          html,
          'text/html'
        )
        const newItems = documentFragment.querySelector(targetClass)
        const targetContainer = document.querySelector(targetClass)

        // If content exist, insert them into the content grid
        if (newItems && targetContainer) {
          targetContainer.insertAdjacentHTML(
            this.direction === 'previous' ? 'afterbegin' : 'beforeend',
            newItems.innerHTML
          )

          window?.yotpoWidgetsContainer?.initWidgets()
        }

        // Rerender component to update its state with the new content
        this.rerenderComponent(documentFragment)
        this.stopLoading()
      })
      .catch((error) => {
        console.error('Error loading more content:', error)
      })
  }

  // Update the URL in the browser's history without reloading the page
  updatePageUrl(url) {
    window.history.pushState({}, '', url)
  }

  // Disable the button and start a loading animation
  startLoading() {
    this.loadButton.disabled = true
    this.loadButton.classList.add('animate-pulse')
  }

  // Re-enable the button and stop the loading animation
  stopLoading() {
    this.loadButton.disabled = false
    this.loadButton.classList.remove('animate-pulse')
  }

  // Replace the current component with a new one from the fetched data
  rerenderComponent(data) {
    if (!data) return
    const elId = `#${this.getAttribute('id')}`

    const newLoadMore = data.querySelector(elId)?.outerHTML || ''
    this.outerHTML = newLoadMore
  }
}

customElements.define('load-more', ComponentLoadMore)
